import { useEffect, useState } from "react";

/**
 * True when the viewport is taller than it is wide.
 *
 * A media-query subscription rather than a resize listener: `(orientation: portrait)`
 * fires exactly on the flip and never during a same-orientation resize, which is all
 * either consumer cares about. Used by the landing backdrop swap and by the display's
 * adaptive layout (a view with `adaptiveLayout` transposes its regions when the
 * screen's orientation disagrees with the authored aspect).
 */
export function useIsPortrait(): boolean {
  const [portrait, setPortrait] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia("(orientation: portrait)").matches,
  );
  useEffect(() => {
    const mq = window.matchMedia("(orientation: portrait)");
    const on = () => setPortrait(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return portrait;
}
